export function convertMb(x: number) {
	// bytes
	let fileSizeMB = Math.round(x / 1024 ** 2);
	return fileSizeMB;
}
